export const templateToNodeList = template => {
    try {
        return new DOMParser().parseFromString(template, 'text/html').body.children;
    } catch (error) {
        return [];
    }
};

export const appendNodesTo = (nodes, target) => {
    Array.from(nodes).forEach(node => {
        target.appendChild(node);
    });
    return target;
};
